export default __webpack_public_path__ + "static/screenshot_3-cfc482068a9b37639ed2aaf8428445e4.png";